import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getMembershiplist } from "../../../redux/membership/action";
import MemebershipSwiperSlide from "./MemebershipSwiperSlide";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";

export default function UpgradeMembership() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [tab, setTab] = useState(location?.state?.mtype || 1);
  const [billingPeriod, setBillingPeriod] = useState('monthly');
  const membershiplist = useSelector(
    ({ membership: { membershiplist } }) => membershiplist,
  );
  const path = "Assets/scss/membership.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    if (location?.state?.mtype) {
      setTab(location.state.mtype);
    }
    if (location?.state?.returnUrl) {
      localStorage.setItem("membershipReturnUrl", location.state.returnUrl);
    }
  }, [location?.state?.mtype, location?.state?.returnUrl]);

  useEffect(() => {
    const data = { mtype: tab, checkpermission: location?.state?.checkpermission }
    dispatch(getMembershiplist(data));
  }, [tab, dispatch]);

  const handleTabChange = (newTab) => {
    setTab(newTab);
  };

  const handleBillingPeriodChange = (period) => {
    setBillingPeriod(period);
  };

  return (
    <div className=" upgrade-membership">
      <div className=" membership-det">
        <div className="col-md-6 mx-auto">
          <h6>URXPRT MEMBERSHIP</h6>
          <h2>Explore Our Pricing Options. Find the Perfect Plan for You</h2>
        </div>
        <ul className="nav nav-tabs" style={{ width: 'max-content', maxWidth: '100%' }}>
          <li className="nav-item">
            <a

              data-toggle="tab"
              className={`nav-link ${tab == 1 ? "active" : ""}`}
              onClick={() => handleTabChange(1)}
            >
              Local Plans
            </a>
          </li>
          <li className="nav-item">
            <a

              data-toggle="tab"
              className={`nav-link ${tab == 2 ? "active" : ""}`}
              onClick={() => handleTabChange(2)}
            >
              Global Plans
            </a>
          </li>
          <li className="nav-item">
            <a

              data-toggle="tab"
              className={`nav-link ${tab == 3 ? "active" : ""}`}
              onClick={() => handleTabChange(3)}
            >
              Regional Plans
            </a>
          </li>
        </ul>

        {/* Monthly and Annually Tabs */}
        <div className="billing-period-tabs mt-3">
          <div className="billing-toggle" style={{
            display: 'flex',
            backgroundColor: 'white',
            border: '1px solid #e0e0e0',
            borderRadius: '25px',
            padding: '2px',
            width: 'fit-content',
            margin: '0 auto'
          }}>
            <button
              className={`nav-link billing-btn ${billingPeriod == 'monthly' ? 'active' : ''}`}
              onClick={() => handleBillingPeriodChange('monthly')}
              style={{
                border: 'none',
                borderRadius: '23px',
                padding: '8px 24px',
                fontSize: '14px',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                backgroundColor: billingPeriod == 'monthly' ? '#ff6b35' : 'white',
                color: billingPeriod == 'monthly' ? 'white' : '#1e3a8a',
                minWidth: '100px'
              }}
            >
              Monthly
            </button>
            <button
              className={`nav-link billing-btn ${billingPeriod == 'annually' ? 'active' : ''}`}
              onClick={() => handleBillingPeriodChange('annually')}
              style={{
                border: 'none',
                borderRadius: '23px',
                padding: '8px 24px',
                fontSize: '14px',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                backgroundColor: billingPeriod == 'annually' ? '#ff6b35' : 'white',
                color: billingPeriod == 'annually' ? 'white' : '#1e3a8a',
                minWidth: '100px'
              }}
            >
              Annually
            </button>
          </div>
        </div>

      </div>
      <div className="tab-content">
        <div className={`tab-pane ${tab == 1 ? "active" : ""}`} id="local">
          <MemebershipSwiperSlide membershiplist={membershiplist} billingPeriod={billingPeriod} />
        </div>
        <div className={`tab-pane ${tab == 2 ? "active" : ""}`} id="global">
          <MemebershipSwiperSlide membershiplist={membershiplist} billingPeriod={billingPeriod} />
        </div>
        <div className={`tab-pane ${tab == 3 ? "active" : ""}`} id="regional">
          <MemebershipSwiperSlide membershiplist={membershiplist} billingPeriod={billingPeriod} />
        </div>
      </div>
    </div>
  );
}
